import request from '@/utils/request'

/**
 * 学习记录相关 API
 */

// 学习记录列表（POST /course/record/question_list；V2 可读时单题可含 tokens/structure_status，见 config/questionV2Tokens.js）
export function questionList (data) {
  return request({
    url: '/course/record/question_list',
    method: 'post',
    data
  })
}

/** 添加学习记录（POST /course/record/add；type 1错题本 2生词 3掌握；source 1课程题 2词典词） */
export function recordAdd (data) {
  return request({
    url: '/course/record/add',
    method: 'post',
    data
  })
}

/** 删除学习记录（POST /course/record/del；必传 type：1错题本 2生词 3掌握；id 逗号分隔） */
export function recordDel (data) {
  return request({
    url: '/course/record/del',
    method: 'post',
    data
  })
}
